export const showGlobalShipModeDisplay = (display) => {
   if (display) {
        $('#global-shipping-method').show();
    } else {
    	$('#global-shipping-method').hide();
    }
};
